import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ReportsGroupSearchComponent } from '../reports-group-search/reports-group-search.component';
import { ReportsProviderSearchComponent } from '../reports-provider-search/reports-provider-search.component';
import { ProviderSearchType } from 'src/app/services/models/provider-search-type';

@Component({
  selector: 'app-reports-provider-group-search',
  templateUrl: './reports-provider-group-search.component.html',
  styleUrl: './reports-provider-group-search.component.scss'
})

export class ReportsProviderGroupSearchComponent {

  @ViewChild('groupsearchcomponent') groupsearchcomponent: ReportsGroupSearchComponent
  @ViewChild('providersearchcomponent') providersearchcomponent: ReportsProviderSearchComponent
  @Output() onSearch: EventEmitter<any> = new EventEmitter(null);

  public optionValue: string = '1';

  public selectOption($event) {
    
  }

  public onProviderSearch($event) {
    this.onSearch.emit({type: ProviderSearchType.Provider, id: $event.providerId, name: $event.providerName, tin: $event.providerTin});
  }

  public onGroupSearch($event) {
    this.onSearch.emit({type: ProviderSearchType.Group, id: $event.id, name: $event.name});
  }
}
